import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, message, Select, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../core/data/redux/store';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';
import Table from '../../../core/common/dataTable';
import FilterHeader from './FilterHeader';
import { fetchAllLeaveCancellationRequests, fetchAllLeaveRequests, fetchLeaveCancellationRequestBySupervisor, fetchLeaveRequestBySupervisor, UpdateLeaveCancellation, updateLeaveRequest } from '../../../core/data/redux/attendance/leave/leaveAction';
import { fetchAllOvertimes, fetchOvertimeBySupervisorHierarchy, updateOvertime } from '../../../core/data/redux/attendance/overtime/overtimeAction';
import { all_routes } from '../../router/all_routes';
import { formatDate } from "../../../core/utils/configFormatters";
import { filterData } from '../../../core/common/GlobalFunctions/tableFilters';
import { exportToCSV, exportToExcel } from '../../../core/common/GlobalFunctions/exportTableData';
import { getStatusCards } from './StatusSummaryCards';
import { fetchAllAssetRequests, updateAssetRequest } from '../../../core/data/redux/asset/assetRequest/assetRequestAction';
import { fetchAllMaintenances, fetchAssetMaintenanceBySupervisorHierarchy, updateMaintenance } from '../../../core/data/redux/asset/assetMaintenanceAction/assetMaintenanceAction';
import { fetchAllExpenses, fetchExpensesBySupervisorHierarchy, updateExpense } from '../../../core/data/redux/payroll/Accounting/expenses/expenseActions';
import { fetchAllWorkformHome, fetchWorkFromHomeBySupervisorHierarchy } from '../../../core/data/redux/attendance/workfromrequest/workfromhome.action';
import { UpdateWorkfromHomeByAdmin } from '../../../core/data/redux/attendance/workfromrequest/workfromhome.action';
import { useAppConfig } from '../../../customhooks/useAppConfig';
import { updateWorkLog, updateWorkLogByHr } from '../../../core/data/redux/attendance/timeworkSheet/timeworkSheetAction';

import { CloudFilled, LoadingOutlined } from '@ant-design/icons';
import { fetchAllWorkLogs } from '../../../core/data/redux/attendance/timeworkSheet/timeworkSheetAction';
import { fetchAllleave_Encashment, fetchLeaveEncashmentBySupervisorHierarchy, UpdateEncashmentByHr } from '../../../core/data/redux/attendance/leave_encashment/leave.Action';
import { getEmployeeByUserId } from '../../../core/data/redux/employee/employeeAction';
import { fetchAssetRequestBySupervisorHierarchy } from '../../../core/data/redux/asset/asset/assetActions';
import { fetchWorklogsBySupervisorHierarchy } from '../../../core/data/redux/reports/timesheet_report/timesheet.Action';
import { fetchAllResignations, resignationBySupervisorHierarchy, updateResignationStatus } from '../../../core/data/redux/resignation/resignationAction';

import { Modal, Badge, Row, Col, Card, Image } from "react-bootstrap";
const { TabPane } = Tabs;

const statusMappingReverse: Record<number, string> = {
  1: "Pending",
  2: "Approved",
  3: "Rejected"
};

const statusMapping: Record<string, number> = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
};

const RequestDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [selectedOvertimeStatus, setSelectedOvertimeStatus] = useState("");
  const [selectedOvertimeSort, setSelectedOvertimeSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [overtimeTableKey, setOvertimeTableKey] = useState(0);
  const [assetTableKey, setAssetTableKey] = useState(0);
  const [assetMaintenaceTableKey, setAssetMaintenaceTableKey] = useState(0);
  const [expenseTableKey, setExpenseTableKey] = useState(0);
  const [WFHTableKey, setWFHTableKey] = useState(0);
  const [timeTableKey, settimeTableKey] = useState(0);
  const [enhancementKey, setenhancementTableKey] = useState(0);
  const [cancellationKey, setcancellationKey] = useState(0);
  const [resignationKey, setResignationReqKey] = useState(0);
  const [activeTab, setActiveTab] = useState("1");
  const { user } = useSelector((state: any) => state.auth);
  const [modalType, setModalType] = useState<"Leave" | "Overtime" | "Asset" | "AssetMaintenance" | "Reimbursement" | "WorkFromHome" | "TimeSheet" | "Encashment" | "LeaveCancellation" | null>(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState<any>(null);
  const [modalLoadingIds, setModalLoadingIds] = useState<number[]>([]);


  const handleWorkedHrsClick = (record: any) => {
    setSelectedDetails(record);
    setIsDetailsModalOpen(true);
  };

  const handleTimesheetStatusChangeFromModal = (value: string, item: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(item);  // IMPORTANT → pass *item*, not whole record
      setRejectModalVisible(true);
    } else {
      updateTimesheetStatusFromModal(value, item);
    }
  };


  const updateTimesheetStatusFromModal = async (status: string, item: any, description = "") => {
    setModalLoadingIds(prev => [...prev, item.work_id]);

    const payload = [{
      EmployeeID: item.EmployeeID,
      work_id: item.work_id,
      requestStatus: status,
      modifiedBy: user?.UserId,
      ...(status === "Rejected" && { RejectDescription: description }),
    }];

    const result = await dispatch(updateWorkLogByHr({ data: payload }));

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Status updated");

      // update UI inside modal
      setSelectedDetails((prev: any) => ({
        ...prev,
        details: prev.details.map((d: any) =>
          d.work_id === item.work_id ? { ...d, requestStatus: status } : d
        )
      }));

      // OPTIONAL: refresh whole table
      dispatch(fetchAllWorkLogs());

    } else {
      message.error("Failed to update");
    }

    setModalLoadingIds(prev => prev.filter(id => id !== item.work_id));
  };




  //maintanance data  
  const { maintenances = [] } = useSelector((state: any) => state.asset.assetMaintenance);
  const { maintenanceBySupervisor = [] } = useSelector((state: any) => state.asset.assetMaintenance);
  const maintenanceData = user?.role_name === "Admin" ? maintenances : maintenanceBySupervisor;

  //leave data
  const { leaveRequests = [] } = useSelector((state: any) => state.attendance.leaveRequests);
  const { leaveRequestsBySupervisor = [] } = useSelector((state: any) => state.attendance.leaveRequests);
  const leaveData = user?.role_name === "Admin" ? leaveRequests : leaveRequestsBySupervisor;

  // overtime data 
  const { overtimes = [] } = useSelector((state: any) => state.attendance.overtime);
  const { OvertimeBySupervisor = [] } = useSelector((state: any) => state.attendance.overtime);
  const overtimeData = user?.role_name === "Admin" ? overtimes : OvertimeBySupervisor;

  // asset data
  const { assetRequests = [] } = useSelector((state: any) => state.asset.assetRequest);
  const { assetRequestBySuperwiser = [] } = useSelector((state: any) => state.asset.newAsset);
  const assetData = user?.role_name === "Admin" ? assetRequests : assetRequestBySuperwiser;

  // expense data
  const { records } = useSelector((state: any) => state.accounting.expenses);
  const { expensesBySupervisorHierarchy = [] } = useSelector((state: any) => state.accounting.expenses);
  const expenseData = user?.role_name === "Admin" ? records : expensesBySupervisorHierarchy;

  // workfromhome data
  const { workfromhome } = useSelector((state: any) => state.workfromHome);
  const { workformhomeBySupervisor } = useSelector((state: any) => state.workfromHome);
  const wfhData = user?.role_name === "Admin" ? workfromhome : workformhomeBySupervisor;

  //resignation data
  const resignation = useSelector((state: any) => state.resignation.resignation);
  const resignationBySupervisor = useSelector((state: any) => state.resignation.resignationBySupervisor);
  const resignationData = user?.role_name === "Admin" ? resignation : resignationBySupervisor;

  const [leaveloading, setLeaveLoadingIds] = useState<string[]>([]);
  const [overtimeLoadingIds, setOvertimeLoadingIds] = useState<number[]>([]);
  const [assetLoadingIds, setAssetLoadingIds] = useState<number[]>([]);
  const [maintenanceLoadingIds, setMaintenanceLoadingIds] = useState<number[]>([]);
  const [expenseLoadingIds, setExpenseLoadingIds] = useState<number[]>([]);
  const [wfhLoadingIds, setWfhLoadingIds] = useState<number[]>([]);
  const [timesheetLoadingIds, settimesheetLoadingIds] = useState<number[]>([]);
  const [encashLoadingIds, setencashLoadingIds] = useState<number[]>([]);
  const [encancelLoadingIds, setencancelLoadingIds] = useState<number[]>([]);
  const [loadingIds, setLoadingIds] = useState<number[]>([]);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const employeeId = employeesbyUser?.employeeId;


  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [currentRejectRecord, setCurrentRejectRecord] = useState<any>(null);
  const [rejectDescription, setRejectDescription] = useState("");

  // worklog data
  const { workLogs, loading } = useSelector((state: any) => state.attendance.worklog);
  const { workLogsBySupervisor } = useSelector((state: any) => state.attendance.worklog);
  const worklogData = user?.role_name === "Admin" ? workLogs : workLogsBySupervisor;

  function filtertimeData(data: any[]) {
    return data.map(emp => ({
      project_name: emp.project_name || "N/A",
      employee_name: emp.employee_name || "N/A",
      requestStatus: emp.requestStatus || "N/A",
      created_at: emp.created_at || "N/A",
      description: emp.description || "N/A",
      status: emp.status || "N/A",
      hours_logged: emp.hours_logged || "N/A",
      total_hours: emp.total_hours || "N/A",
      remaining_hours: emp.remaining_hours || "N/A"
    }));
  }
  const DataTimeSheeetForExport = filtertimeData(worklogData);

  // encashment data
  const [encashment, setencashment] = useState<any>([]);
  const [leaveEncashmentBySupervisor, setLeaveEncashmentBySupervisor] = useState<any>([]);
  const leaveEncashmentData = user?.role_name === "Admin" ? encashment : leaveEncashmentBySupervisor;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dataEncashment = Array.isArray(leaveEncashmentData)
    ? leaveEncashmentData
    : [];

  // leaveCancellation data
  const [leavecancellation, setleavecancellation] = useState<any>([]);
  const { leaveCancellationRequestBySupervisor = [] } = useSelector((state: any) => state.attendance.leaveRequests);
  const leaveCancellationData = user?.role_name === 'Admin' ? leavecancellation : leaveCancellationRequestBySupervisor

  function filterCancellationData(data: any[]) {
    return data.map(emp => ({
      FromDate: emp.FromDate || "N/A",
      ToDate: emp.ToDate || "N/A",
      Duration: emp.Duration || "N/A",
      employeeName: emp.employeeName || "N/A",
      LeaveType: emp.LeaveType || "N/A",
      LeaveRequestStatus: emp.LeaveRequestStatus || "N/A",
      LeaveMode: emp.LeaveMode || "N/A",
      cancellation_reason: emp.cancellation_reason || "N/A",
      Cancellation_status: emp.Cancellation_status || "N/A"
    }));
  }

  const DatafromExportCancellation = filterCancellationData(leaveCancellationData)

  useEffect(() => {
    user?.role_name === 'Admin' ? dispatch(fetchAllLeaveRequests()) : dispatch(fetchLeaveRequestBySupervisor({ supervisorId: employeeId, includeSelf: false }))
    if (user?.role_name === "Admin") {
      dispatch(fetchAllOvertimes());
    } else {
      dispatch(fetchOvertimeBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: false }))
    }
    user?.role_name === 'Admin' ? dispatch(fetchAllAssetRequests()) : dispatch(fetchAssetRequestBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: false }))
    user?.role_name === 'Admin' ? dispatch(fetchAllMaintenances()) : dispatch(fetchAssetMaintenanceBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: false }))
    user?.role_name === 'Admin' ? dispatch(fetchAllExpenses()) : dispatch(fetchExpensesBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: false }))
    user?.role_name === 'Admin' ? dispatch(fetchAllWorkformHome()) : dispatch(fetchWorkFromHomeBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: false }))
    user?.role_name === 'Admin' ? dispatch(fetchAllWorkLogs()) : dispatch(fetchWorklogsBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: false }))
    user?.role_name === 'Admin' ? dispatch(fetchAllleave_Encashment()).then((res) => { setencashment(res.payload.data) }) : dispatch(fetchLeaveEncashmentBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: false })).then((res) => { setLeaveEncashmentBySupervisor(res.payload); });
    user?.role_name === 'Admin' ? dispatch(fetchAllLeaveCancellationRequests()).then((res) => { setleavecancellation(res.payload.data) }) : dispatch(fetchLeaveCancellationRequestBySupervisor({ supervisorId: employeeId, includeSelf: false }))
    user?.role_name === 'Admin' ? dispatch(fetchAllResignations()) : dispatch(resignationBySupervisorHierarchy(employeeId));
  }, [dispatch, employeeId, user?.role_name]);

  useEffect(() => {
    dispatch(getEmployeeByUserId({ userId: user?.UserId }));
  }, [dispatch, user?.UserId])



  const filteredLeaves = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== "All" ? { LeaveRequestStatus: selectedStatus } : {};
    return filterData(leaveData, filters, "CreatedAt", "CreatedAt", selectedSort);
  }, [leaveData, selectedStatus, selectedSort]);


  const filteredWorkfromhome = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== "All" ? { RequestStatus: selectedStatus } : {};
    return filterData(wfhData, filters, "CreatedAt", "CreatedAt", selectedSort);
  }, [wfhData, selectedStatus, selectedSort]);

  const filteredOvertimes = useMemo(() => {
    const statusCode = statusMapping[selectedOvertimeStatus] ?? null;
    const filters = statusCode ? { OvertimeStatus: statusCode } : {};
    return filterData(overtimeData, filters, "CreatedAt", "CreatedAt", selectedOvertimeSort);
  }, [overtimeData, selectedOvertimeStatus, selectedOvertimeSort]);

  const filteredAssetRequests = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== "All" ? { AssetRequestStatus: selectedStatus } : {};
    return filterData(assetData, filters, "CreatedAt", "CreatedAt", selectedSort);
  }, [assetData, selectedStatus, selectedSort]);

  const filteredAssetMaintenaceData = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== 'All'
      ? { request_status: selectedStatus }
      : {};
    return filterData(maintenanceData || [], filters, 'created_at', 'created_at', selectedSort);
  }, [maintenanceData, selectedStatus, selectedSort]);

  const filteredExpenseData = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== 'All'
      ? { requestStatus: selectedStatus }
      : {};
    return filterData(expenseData || [], filters, 'created_at', 'created_at', selectedSort);
  }, [expenseData, selectedStatus, selectedSort]);

  const filteredtimesheetData = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== 'All'
      ? { requestStatus: selectedStatus }
      : {};
    return filterData(worklogData || [], filters, 'created_at', 'created_at', selectedSort);
  }, [worklogData, selectedStatus, selectedSort]);

  const filteredencashmentData = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== 'All'
      ? { Status: selectedStatus }
      : {};
    return filterData(dataEncashment || [], filters, 'created_at', 'created_at', selectedSort);
  }, [dataEncashment, selectedStatus, selectedSort]);


  const filteredcancellationdata = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== 'All'
      ? { Cancellation_status: selectedStatus }
      : {};
    return filterData(leaveCancellationData || [], filters, 'CreatedAt', 'CreatedAt', selectedSort);
  }, [leaveCancellationData, selectedStatus, selectedSort]);

  const filteredResignation = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== "All" ? { LeaveRequestStatus: selectedStatus } : {};
    return filterData(resignationData, filters, "CreatedAt", "CreatedAt", selectedSort);
  }, [resignationData, selectedStatus, selectedSort]);

  const exportLeavesRequest = leaveData?.map((item: any) => ({
    // Id: item.Id,
    Description: item.Description || "N/A",
    FromDate: item.FromDate ? item.FromDate.split("T")[0] : "N/A",
    ToDate: item.ToDate ? item.ToDate.split("T")[0] : "N/A",
    Duration: item.Duration ?? "N/A",
    // EmployeeId: item.EmployeeId || "N/A",
    // LeaveTypeId: item.LeaveTypeId || "N/A",
    LeaveRequestStatus: item.LeaveRequestStatus || "N/A",
    CreatedAt: item.CreatedAt ? item.CreatedAt.split("T")[0] : "N/A",
    // CreatedBy: item.CreatedBy || "N/A",
    ModifiedAt: item.ModifiedAt ? item.ModifiedAt.split("T")[0] : "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
    LeaveMode: item.LeaveMode || "N/A",
    employeeName: item.employeeName || "N/A",
    LeaveType: item.LeaveType || "N/A",
  }));

  const exportOvertimes = overtimeData?.map((item: any) => ({
    // Id: item.Id,
    // EmployeeId: item.EmployeeId,
    OvertimeDate: item.OvertimeDate ? new Date(item.OvertimeDate).toISOString().split("T")[0] : "N/A",
    Duration: item.Duration ?? "N/A",
    OvertimeStatus: item.OvertimeStatus || "N/A",
    Description: item.Description || "N/A",
    CreatedAt: item.CreatedAt ? item.CreatedAt.split("T")[0] : "N/A",
    // CreatedBy: item.CreatedBy || "N/A",
    ModifiedAt: item.ModifiedAt ? item.ModifiedAt.split("T")[0] : "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
    RemainingHours: item.RemainingHours ?? "N/A",
    employeeName: item.employeeName || "N/A",
    Overtime_date: item.overtime_date ? item.overtime_date.split("T")[0] : "N/A",
    Overtime: item.overtime ? item.overtime.split("T")[0] : "N/A",
  }));

  const exportAssetRequest = assetData?.map((item: any) => ({
    // Id: item.Id,
    RequestDescription: item.RequestDescription || "N/A",
    RejectDescription: item.RejectDescription || "N/A",
    RequestDate: item.RequestDate ? new Date(item.RequestDate).toISOString().split("T")[0] : "N/A",
    AssetCategoryId: item.AssetCategoryId || "N/A",
    Quantity: item.Quantity ?? "N/A",
    // EmployeeId: item.EmployeeId || "N/A",
    AssetRequestStatus: item.AssetRequestStatus || "N/A",
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toISOString().split("T")[0] : "N/A",
    // CreatedBy: item.CreatedBy || "N/A",
    ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toISOString().split("T")[0] : "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
    Name: item.Name || "N/A",
    EmployeeName: item.EmployeeName || "N/A",
    AssetCategoryName: item.AssetCategoryName || "N/A",
  }));

  const exportAssetRequestMaintainance = maintenanceData?.map((item: any) => ({
    // maintenance_id: item.maintenance_id,
    // asset_id: item.asset_id,
    // asset_details_id: item.asset_details_id,
    maintenance_type: item.maintenance_type || "N/A",
    maintenance_date: item.maintenance_date ? new Date(item.maintenance_date).toISOString().split("T")[0] : "N/A",
    next_due_date: item.next_due_date ? new Date(item.next_due_date).toISOString().split("T")[0] : "N/A",
    cost: item.cost ?? "N/A",
    vendor: item.vendor || "N/A",
    description: item.description || "N/A",
    status: item.status || "N/A",
    request_status: item.request_status || "N/A",
    created_at: item.created_at ? new Date(item.created_at).toISOString().split("T")[0] : "N/A",
    // created_by: item.created_by || "N/A",
    modified_at: item.modified_at ? new Date(item.modified_at).toISOString().split("T")[0] : "N/A",
    // modified_by: item.modified_by || "N/A",
    vendor_name: item.vendor_name || "N/A",
    total_assets: item.total_assets ?? "N/A",
  }));

  const exportExpenseData = expenseData?.map((item: any) => ({
    // expense_id: item.expense_id,
    expense_name: item.expense_name || "N/A",
    expense_date: item.expense_date ? new Date(item.expense_date).toISOString().split("T")[0] : "N/A",
    amount: item.amount ?? "N/A",
    payment_method: item.payment_method || "N/A",
    status: item.status || "N/A",
    // createdBy: item.createdBy || "N/A",
    // modifiedBy: item.modifiedBy || "N/A",
    createdAt: item.createdAt ? new Date(item.createdAt).toISOString().split("T")[0] : "N/A",
    modifiedAt: item.modifiedAt ? new Date(item.modifiedAt).toISOString().split("T")[0] : "N/A",
    requestStatus: item.requestStatus || "N/A",
    paymentStatus: item.paymentStatus || "N/A",
  }));

  const exportWorkfromhome = wfhData?.map((item: any) => ({
    // Id: item.Id,
    // EmployeeId: item.EmployeeId,
    Days: item.Days ?? "N/A",
    FromDate: item.FromDate ? new Date(item.FromDate).toISOString().split("T")[0] : "N/A",
    ToDate: item.ToDate ? new Date(item.ToDate).toISOString().split("T")[0] : "N/A",
    RequestStatus: item.RequestStatus || "N/A",
    // CreatedBy: item.CreatedBy || "N/A",
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toISOString().split("T")[0] : "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
    ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toISOString().split("T")[0] : "N/A",
    Description: item.Description || "N/A",
    EmployeeName: item.EmployeeName || "N/A",
  }));

  const exportResignation = resignationData?.map((item: any) => ({
    Resigning_Employee: item.Resigning_Employee || "N/A",
    Department: item.Department || "N/A",
    Notice_Date: item.Notice_Date ? new Date(item.Notice_Date).toISOString().split("T")[0] : "N/A",
    Resignation_Date: item.Resignation_Date ? new Date(item.Resignation_Date).toISOString().split("T")[0] : "N/A",
    ResignationStatus: item.ResignationStatus || "N/A",
  }))

  const exportLeaveEncashments = dataEncashment?.map((item: any) => ({
    EmployeeName: item.EmployeeName || "N/A",
    LeaveType: item.LeaveType || "N/A",
    LeaveTypeName: item.LeaveTypeName || "N/A",
    LeavesAvailable: item.LeavesAvailable ?? "N/A",
    RequestType: item.RequestType || "N/A",
    Status: item.Status || "N/A",
    Remarks: item.Remarks || "N/A",
    CreatedAt: item.CreatedAt ? item.CreatedAt.split("T")[0] : "N/A",
    ModifiedAt: item.ModifiedAt ? item.ModifiedAt.split("T")[0] : "N/A",
  }));


  useEffect(() => setTableKey(prev => prev + 1), [filteredLeaves]);
  useEffect(() => setOvertimeTableKey(prev => prev + 1), [filteredOvertimes]);
  useEffect(() => setAssetTableKey(prev => prev + 1), [filteredAssetRequests]);
  useEffect(() => setAssetMaintenaceTableKey(prev => prev + 1), [filteredAssetMaintenaceData]);
  useEffect(() => setExpenseTableKey(prev => prev + 1), [filteredExpenseData]);
  useEffect(() => setWFHTableKey(prev => prev + 1), [filteredWorkfromhome]);
  useEffect(() => settimeTableKey(prev => prev + 1), [workLogs]);
  useEffect(() => setenhancementTableKey(prev => prev + 1), [dataEncashment]);
  useEffect(() => setcancellationKey(prev => prev + 1), [filteredcancellationdata]);
  useEffect(() => setResignationReqKey(prev => prev + 1), [filteredResignation]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalRecord, setModalRecord] = useState<any>(null);
  const [daysInput, setDaysInput] = useState<number>(1);

  const updateLeaveStatus = async (status: string, record: any, opts?: { duration?: number; description?: string }) => {
    setLeaveLoadingIds(prev => [...prev, record.Id]);

    const payload: any = {
      LeaveRequestStatus: status,
      EmployeeId: record?.EmployeeId,
      LeaveTypeId: record?.LeaveTypeId,
      Duration: opts?.duration ?? record?.Duration,
      LeaveMode: record?.LeaveMode,
    };

    if (status === "Rejected" && opts?.description) {
      payload.RejectDescription = opts.description;
    }

    const result = await dispatch(updateLeaveRequest({ leaveRequestId: record.Id, data: payload }));
    if (result.meta.requestStatus === "fulfilled") {
      message.success("Leave request status updated successfully");
      dispatch(fetchAllLeaveRequests());
      setIsStatusUpdating(false);
    } else {
      message.error("Failed to update leave request status");
      setIsStatusUpdating(false);
    }
    setLeaveLoadingIds(prev => prev.filter(id => id !== record.Id));
  };

  const [isStatusUpdating, setIsStatusUpdating] = useState(false);

  const handleStatusChange = (value: string, record: any) => {
    setIsStatusUpdating(true);
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("Leave");
      setRejectModalVisible(true);
      return;
    }

    if (value === "Approved" && record.LeaveTypeFrequency === "On Request") {
      setModalRecord({ ...record, LeaveRequestStatus: value });
      setDaysInput(record.Duration ?? 1);
      setIsModalVisible(true);
      return;
    }

    updateLeaveStatus(value, record);
  };



  // const handleOvertimeStatusChange = async (value: string, record: any) => {
  //   setOvertimeLoadingIds(prev => [...prev, record.Id]);
  //   const result = await dispatch(updateOvertime({
  //     overtimeId: record.Id,
  //     data: {
  //       OvertimeStatus: value, ModifiedBy: user.UserId,
  //       EmployeeId: record?.EmployeeId
  //     },
  //   }));
  //   result.meta.requestStatus === 'fulfilled' ? message.success("Status updated successfully") : message.error("Failed to update status");
  //   if (user?.role_name === "Admin") {
  //     dispatch(fetchAllOvertimes());
  //   } else {
  //     dispatch(fetchOvertimeBySupervisorHierarchy({ supervisorId: employeeId, includeSelf: true }));
  //   }
  //   setOvertimeLoadingIds(prev => prev.filter(id => id !== record.Id));
  // };


  const updateOvertimeStatus = async (statusLabel: string, record: any, description = "") => {
    setOvertimeLoadingIds(prev => [...prev, record.Id]);
    const payload: any = {
      OvertimeStatus: statusMapping[statusLabel],
      ModifiedBy: user.UserId,
      EmployeeId: record?.EmployeeId,
    };

    if (statusLabel === "Rejected") {
      payload.RejectDescription = description;
    }

    const result = await dispatch(updateOvertime({ overtimeId: record.Id, data: payload }));

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Overtime status updated successfully");
      if (user?.role_name === "Admin") {
        dispatch(fetchAllOvertimes());
      } else {
        dispatch(
          fetchOvertimeBySupervisorHierarchy({
            supervisorId: employeeId,
            includeSelf: true,
          })
        );
      }
    } else {
      message.error("Failed to update overtime status");
    }

    setOvertimeLoadingIds(prev => prev.filter(id => id !== record.Id));
  };

  // Handler for dropdown change
  const handleOvertimeStatusChange = (value: string, record: any) => {
    const statusLabel = statusMappingReverse[Number(value)];
    if (statusLabel === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("Overtime");
      setRejectModalVisible(true);
    } else {
      updateOvertimeStatus(statusLabel, record);
    }
  };


  const updateStatus = async (status: string, record: any, description = "") => {
    setAssetLoadingIds(prev => [...prev, record.Id]);

    const payload: any = {
      AssetRequestStatus: status,
      ModifiedBy: user.UserId,
      EmployeeId: record?.EmployeeId,
    };
    if (status === "Rejected") {
      payload.RejectDescription = description;
    }
    const result = await dispatch(updateAssetRequest({ id: record.Id, data: payload, }));
    if (result.meta.requestStatus === "fulfilled") {
      message.success("Asset request status updated successfully");
      dispatch(fetchAllAssetRequests());
    } else {
      message.error("Failed to update asset request status");
    }
    setAssetLoadingIds(prev => prev.filter(id => id !== record.Id));
  };

  const handleAssetStatusChange = (value: string, record: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("Asset");
      setRejectModalVisible(true);
    } else {
      updateStatus(value, record);
    }
  };

  const getHierarchyStatus = (record: any): "Pending" | "Approved" | "Rejected" => {
    const { manager_status, hod_status, hr_status } = record;

    if (
      manager_status === "Rejected" ||
      hod_status === "Rejected" ||
      hr_status === "Rejected"
    ) {
      return "Rejected";
    }

    if (
      manager_status === "Approved" &&
      hod_status === "Approved" &&
      hr_status === "Approved"
    ) {
      return "Approved";
    }

    return "Pending";
  };

  const syncHierarchyStatusToBackend = async (record: any) => {
    const newStatus = getHierarchyStatus(record);

    if (record.ResignationStatus !== newStatus) {
      const payload = {
        resignationId: record.ResignationId,
        status: newStatus,
        ModifiedBy: employeeId,
      };

      const result = await dispatch(updateResignationStatus(payload));

      if (result.meta.requestStatus === "fulfilled") {
        message.success(`Resignation status updated to ${newStatus}`);
      } else {
        message.error("Failed to update resignation status");
      }
    }
  };

  const updateStatusApproval = async (status: string, record: any) => {
    setLoadingIds((prev) => [...prev, record.ResignationId]);
    setIsStatusUpdating(true);

    const result = await dispatch(
      updateResignationStatus({
        resignationId: record.Id,
        status,
        ModifiedBy: employeeId,
      })
    );

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Status updated successfully");

      await fetchAllResignations();

      const updatedRecord = resignationBySupervisor.find(
        (r: any) => r.ResignationId === record.ResignationId
      );

      if (updatedRecord) {
        await syncHierarchyStatusToBackend(updatedRecord);
      }
    } else {
      message.error("Failed to update resignation status");
    }

    setLoadingIds((prev) => prev.filter((id) => id !== record.ResignationId));
    setIsStatusUpdating(false);
  };




  // const handleAssetStatusChange = async (value: string, record: any) => {
  //   setAssetLoadingIds(prev => [...prev, record.Id]);
  //   const result = await dispatch(updateAssetRequest({
  //     id: record.Id,
  //     data: {
  //       AssetRequestStatus: value,
  //       ModifiedBy: user.UserId,
  //       EmployeeId: record?.EmployeeId
  //     },
  //   }));
  //   if (result.meta.requestStatus === "fulfilled") {
  //     message.success("Asset request status updated successfully");
  //     dispatch(fetchAllAssetRequests());
  //   } else {
  //     message.error("Failed to update asset request status");
  //   }
  //   setAssetLoadingIds(prev => prev.filter(id => id !== record.Id));
  // };


  const updateAssetMaintenanceStatus = async (status: string, record: any, description = "") => {
    setMaintenanceLoadingIds(prev => [...prev, record.maintenance_id]);
    const payload: any = {
      request_status: status,
      modified_by: user?.UserId,
      EmployeeId: record?.employeeId,
    };

    if (status === "Rejected") {
      payload.RejectDescription = description;
    }

    const result = await dispatch(
      updateMaintenance({
        id: record.maintenance_id,
        data: payload,
      })
    );

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Maintenance status updated successfully");
      dispatch(fetchAllMaintenances());
    } else {
      message.error("Failed to update maintenance status");
    }

    setMaintenanceLoadingIds(prev =>
      prev.filter(id => id !== record.maintenance_id)
    );
  };

  const handleMaintenanceStatusChange = (value: string, record: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("AssetMaintenance");
      setRejectModalVisible(true);
    } else {
      updateAssetMaintenanceStatus(value, record);
    }
  };

  const updateExpenseStatus = async (value: string, record: any, description = "") => {
    setExpenseLoadingIds(prev => [...prev, record.expense_id]);


    const payload: any = {
      requestStatus: value,
      Modified_by: user?.UserId,
      EmployeeId: employeeId,
    };

    if (value === "Rejected") {
      payload.RejectDescription = description;
    }

    const result = await dispatch(
      updateExpense({
        id: record.expense_id,
        data: payload,
      })
    );

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Reimbursement status updated successfully");
      dispatch(fetchAllExpenses());
    } else {
      message.error("Failed to update Reimbursement status");
    }

    setExpenseLoadingIds(prev => prev.filter(id => id !== record.expense_id));
  };

  const handleExpenseStatusChange = (value: string, record: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("Reimbursement");
      setRejectModalVisible(true);
    } else {
      updateExpenseStatus(value, record);
    }
  };

  const updateWorkfromStatus = async (status: string, record: any, description = "") => {

    setWfhLoadingIds(prev => [...prev, record.Id]);


    const payload: any = {
      RequestStatus: status,
      modifiedBy: user?.UserId,
      EmployeeId: record?.EmployeeId,
    };

    if (status === "Rejected") {
      payload.RejectDescription = description;
    }

    const result = await dispatch(
      UpdateWorkfromHomeByAdmin({
        Id: record.Id,
        data: payload,
      })
    );

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Work From Home status updated successfully");
      dispatch(fetchAllWorkformHome());
    } else {
      message.error("Failed to update Work From Home request");
    }

    setWfhLoadingIds(prev => prev.filter(id => id !== record.Id));
  };

  const handleWorkfromStatusChange = (value: string, record: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("WorkFromHome");
      setRejectModalVisible(true);
    } else {
      updateWorkfromStatus(value, record);
    }
  };


  const handleExpensePaymentStatusChange = async (value: string, record: any) => {
    const result = await dispatch(updateExpense({
      id: record.expense_id,
      data: {
        paymentStatus: value,
        modified_by: user?.UserId,
      },
    }));
    if (result.meta.requestStatus === 'fulfilled') {
      message.success('Payment status updated successfully');
      dispatch(fetchAllExpenses());
    } else {
      message.error('Failed to update payment status');
    }
  };


  const updateTimesheetStatus = async (status: string, record: any, description = "") => {
    const workIds = record?.details?.map((d: any) => d.work_id) || [];

    settimesheetLoadingIds(prev => [...prev, ...workIds]);

    const payload = record.details.map((item: any) => ({
      EmployeeID: item.EmployeeID,
      work_id: item.work_id,
      requestStatus: status,
      modifiedBy: user?.UserId,
      ...(status === "Rejected" && { RejectDescription: description }),
    }));


    const result = await dispatch(updateWorkLogByHr({ data: payload }));

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Timesheet updated successfully");
      dispatch(fetchAllWorkLogs());
    } else {
      message.error("Failed to update Timesheet");
    }

    settimesheetLoadingIds(prev => prev.filter(id => !workIds.includes(id)));
  };




  const handleTimesheetStatusChange = (value: string, record: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("TimeSheet");
      setRejectModalVisible(true);
    } else {
      updateTimesheetStatus(value, record);
    }
  };

  const updateEncashmentStatus = async (
    status: string,
    record: any,
    description = ""
  ) => {


    setencashLoadingIds(prev => [...prev, record.task_id]);
    const payload: any = {
      employeeId: record.EmployeeId,
      leavetype: record.LeaveType,
      status: status,
    };

    if (status === "Rejected") {
      payload.RejectDescription = description;
    }

    const result = await dispatch(
      UpdateEncashmentByHr(payload)
    );

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Encashment updated successfully");
      dispatch(fetchAllleave_Encashment()).then((res) => {
        setencashment(res.payload.data);
      });
    } else {
      message.error("Failed to update Encashment");
    }

    setencashLoadingIds(prev =>
      prev.filter(id => id !== record.task_id)
    );
  };


  const handleEncashmentStatusChange = (value: string, record: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("Encashment");
      setRejectModalVisible(true);
    } else {
      updateEncashmentStatus(value, record);
    }
  };


  // const handleleaveCancelStatusChange = async (value: string, record: any) => {
  //   setencancelLoadingIds(prev => [...prev, record.Id]);
  //   console.log(value, record, 'record')
  //   const payload = {
  //     Id: record.Id,
  //     Cancellation_status: value,
  //     EmployeeNumber: record.EmployeeNumber,
  //     Duration: record.Duration,
  //     LeaveTypeId: record.LeaveTypeId,
  //     FromDate: record.FromDate,
  //     ToDate: record.ToDate,
  //     EmployeeId: record.EmployeeId
  //   }

  //   const result = await dispatch(UpdateLeaveCancellation({ leaverequestId: record.Id, data: payload }))
  //     .then((res) => {
  //       if (res.meta.requestStatus === 'fulfilled') {
  //         message.success('Cancellation updated successfully');
  //         dispatch(fetchAllLeaveCancellationRequests())
  //           .then((res) => {
  //             setleavecancellation(res.payload.data)
  //           })
  //       } else {
  //         message.error(res.payload.message)
  //       }
  //     })
  // };

  const updateLeaveCancelStatus = async (
    status: string,
    record: any,
    description = ""
  ) => {
    setencancelLoadingIds(prev => [...prev, record.Id]);
    const payload: any = {
      Id: record.Id,
      Cancellation_status: status,
      EmployeeNumber: record.EmployeeNumber,
      Duration: record.Duration,
      LeaveTypeId: record.LeaveTypeId,
      FromDate: record.FromDate,
      ToDate: record.ToDate,
      EmployeeId: record.EmployeeId,
    };

    if (status === "Rejected" && description) {
      payload.RejectDescription = description;
    }

    const result = await dispatch(
      UpdateLeaveCancellation({ leaverequestId: record.Id, data: payload })
    );

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Cancellation updated successfully");
      const res = await dispatch(fetchAllLeaveCancellationRequests());
      setleavecancellation(res?.payload?.data);
    } else {
      const errMsg =
        result?.payload?.message || "Failed to update leave cancellation";
      message.error(errMsg);
    }

    setencancelLoadingIds(prev => prev.filter(id => id !== record.Id));
  };

  const handleleaveCancelStatusChange = (value: string, record: any) => {
    if (value === "Rejected") {
      setCurrentRejectRecord(record);
      setModalType("LeaveCancellation");
      setRejectModalVisible(true);
    } else {
      updateLeaveCancelStatus(value, record);
    }
  };


  const config = useAppConfig();
  if (!config) return null;

  const statusColors: { [key: string]: string } = {
    Pending: "#f0ad4e",
    Approved: "#5cb85c",
    Rejected: "#d9534f",
  };

  const ExpenseColumns = [
    {
      title: "Reimbursement Name",
      dataIndex: "expense_name",
      sorter: (a: any, b: any) => a.expense_name.length - b.expense_name.length,
    },
    {
      title: "Date",
      dataIndex: "expense_date",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.expense_date.length - b.expense_date.length,
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      sorter: (a: any, b: any) => a.payment_method.length - b.payment_method.length,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a: any, b: any) => a.amount.length - b.amount.length,
    },
    {
      title: "File",
      dataIndex: "doc_path",
      render: (filePath: string) => {
        if (!filePath) return "No File";

        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
        const extension = filePath.split('.').pop()?.toLowerCase();

        const isImage = imageExtensions.includes(extension || "");

        return (
          <a
            href={filePath}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-outline-primary"
            title={isImage ? "View Image" : "Download File"}
          >
            <i className={`ti ${isImage ? 'ti-eye' : 'ti-download'}`} />
          </a>
        );
      },
    },
    {
      title: "Payment Status",
      dataIndex: "paymentStatus",
      render: (paymentStatus: string, record: any) => (
        <Select
          value={paymentStatus}
          onChange={(value) => handleExpensePaymentStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
        >
          {["Paid", "Unpaid"].map((statusOption) => (
            <Select.Option key={statusOption} value={statusOption}>
              <span style={{ color: statusOption === "Paid" ? "green" : "red", fontWeight: 500 }}>
                {statusOption}
              </span>
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Status",
      dataIndex: "requestStatus",
      render: (requestStatus: string, record: any) => (
        <Select
          value={requestStatus}
          onChange={(value) => handleExpenseStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={expenseLoadingIds.includes(record.expense_id)}
        >
          {["Pending", "Approved", "Rejected"].map((statusOption) => (
            <Select.Option key={statusOption} value={statusOption}>
              {statusOption === requestStatus && expenseLoadingIds.includes(record.expense_id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[statusOption], fontWeight: 500 }}>
                {statusOption}
              </span>
            </Select.Option>
          ))}
        </Select>
      )
    },
  ]

  const assetMaintenanceColumns = [
    { title: "Maintenance Type", dataIndex: "maintenance_type" },
    { title: "Maintenance Date", dataIndex: "maintenance_date", render: (text: string) => formatDate(text, config), },
    { title: "Next Due Date", dataIndex: "next_due_date", render: (text: string) => formatDate(text, config), },
    { title: "Cost", dataIndex: "cost" },
    { title: "Vendor", dataIndex: "vendor_name" },
    { title: "Description", dataIndex: "description" },
    {
      title: "Status",
      dataIndex: "request_status",
      render: (request_status: string, record: any) => (
        <Select
          value={request_status}
          onChange={(value) => handleMaintenanceStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={maintenanceLoadingIds.includes(record.maintenance_id)}
        >
          {["Pending", "Approved", "Rejected"].map((statusOption) => (
            <Select.Option key={statusOption} value={statusOption}>
              {statusOption === request_status && maintenanceLoadingIds.includes(record.maintenance_id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[statusOption], fontWeight: 500 }}>
                {statusOption}
              </span>
            </Select.Option>
          ))}
        </Select>
      )
    }
  ];

  const assetColumns = [
    {
      title: "Employee",
      dataIndex: "EmployeeName",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img src={record.EmployeeImage ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" className="img-fluid rounded-circle" />
          </Link>
          <div className="ms-2">
            <Link to="#">{record.EmployeeName}</Link>
          </div>
        </div>
      ),
    },
    { title: "Asset Name", dataIndex: "Name" },
    { title: "Category", dataIndex: "AssetCategoryName" },
    { title: "Quantity", dataIndex: "Quantity" },
    { title: "Request Date", dataIndex: "RequestDate", render: (text: string) => formatDate(text, config), },
    {
      title: "Status",
      dataIndex: "AssetRequestStatus",
      render: (status: string, record: any) => (
        <Select
          value={status}
          onChange={(value) => handleAssetStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={assetLoadingIds.includes(record.Id)}
        >
          {["Pending", "Approved", "Rejected"].map((statusOption) => (
            <Select.Option key={statusOption} value={statusOption}>
              {statusOption === status && assetLoadingIds.includes(record.Id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[statusOption], fontWeight: 500 }}>
                {statusOption}
              </span>
            </Select.Option>
          ))}
        </Select>
      ),
    },
  ];

  const leaveColumns = [
    {
      title: "Employee ID",
      dataIndex: "EmployeeNumber",
      render: (text: any, record: any) => <Link to="#" className="ps-4">{record.EmployeeNumber}</Link>,
      sorter: (a: any, b: any) => a.EmployeeNumber - b.EmployeeNumber,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      render: (text: any, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" className="img-fluid rounded-circle" />
          </Link>
          <div className="ms-2"><Link to="#">{record.employeeName}</Link></div>
        </div>
      ),
    },
    { title: "From", dataIndex: "FromDate", render: (text: string) => formatDate(text, config), },
    { title: "To", dataIndex: "ToDate", render: (text: string) => formatDate(text, config), },
    { title: "No of Days", dataIndex: "Duration" },
    { title: "Leave Type", dataIndex: "LeaveType" },
    {
      title: "Document",
      dataIndex: "DocumentURL",
      render: (text: any, record: any) => {

        // Your document URL from API
        const fileUrl = record.DocumentURL;

        if (!fileUrl) {
          return <span className="text-muted">No File</span>;
        }

        const isImage =
          fileUrl.toLowerCase().endsWith(".jpg") ||
          fileUrl.toLowerCase().endsWith(".jpeg") ||
          fileUrl.toLowerCase().endsWith(".png") ||
          fileUrl.toLowerCase().endsWith(".gif");

        return (
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              overflow: "hidden",
              cursor: "pointer",
              border: "1px solid #ddd",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            onClick={() => window.open(fileUrl, "_blank")}
          >
            {isImage ? (
              <img
                src={fileUrl}
                alt="doc"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <i className="bi bi-file-earmark-pdf" style={{ fontSize: 22 }}></i>
            )}
          </div>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "LeaveRequestStatus",
      render: (text: string, record: any) => (
        <Select
          value={text}
          onChange={(value) => handleStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={
            text === "Approved" ||
            text === "Cancellation" ||
            leaveloading.includes(record.Id) ||
            isStatusUpdating // ✅ freeze all dropdowns
          }
        >
          {["Pending", "Approved", "Rejected"].map(status => (
            <Select.Option key={status} value={status}>
              {status === text && leaveloading.includes(record.Id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[status], fontWeight: 500 }}>
                {status}
              </span>
            </Select.Option>
          ))}
        </Select>
      )
    }

  ];

  const workfromhomecolumns = [
    {
      title: "Employee Name",
      dataIndex: "EmployeeName",
      render: (text: String, record: any) => (
        <h6 className="fw-medium fs-14 text-dark">{text}</h6>
      ),
      sorter: (a: any, b: any) => a.EmployeeName.length - b.EmployeeName.length,
    },
    {
      title: "From Date",
      dataIndex: "FromDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        return new Date(a.FromDate).getTime() - new Date(b.FromDate).getTime();
      },
    },
    {
      title: "To Date",
      dataIndex: "ToDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        return new Date(a.ToDate).getTime() - new Date(b.ToDate).getTime();
      },
    },
    {
      title: "Request Status",
      dataIndex: "RequestStatus",
      render: (RequestStatus: string, record: any) => (
        <Select
          value={RequestStatus}
          onChange={(value) => handleWorkfromStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={wfhLoadingIds.includes(record.Id)}
        >
          {["Pending", "Approved", "Rejected"].map((statusOption) => (
            <Select.Option key={statusOption} value={statusOption}>
              {statusOption === RequestStatus && wfhLoadingIds.includes(record.Id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[statusOption], fontWeight: 500 }}>
                {statusOption}
              </span>
            </Select.Option>
          ))}
        </Select>
      )
    },
    {
      title: "Days",
      dataIndex: "Days",
      sorter: (a: any, b: any) => a.Days.length - b.Days.length,
    },
    {
      title: "Created Date",
      dataIndex: "CreatedAt",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.CreatedAt);
        const dateB = new Date(b.CreatedAt);
        return dateA.getTime() - dateB.getTime();
      },
    },
  ];
  const timesheetcolumns = [
    {
      title: "Employee",
      dataIndex: "employee_name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="avatar avatar-md">
            <img src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" className='img-fluid rounded-circle' />
          </div>
          <div className="ms-2">
            <h6 className="fw-medium">
              <div>{record.employee_name}</div>
            </h6>
            {/* <span className="fs-12 fw-normal ">{record.Role}</span> */}
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.employee_name.length - b.employee_name.length,
    },
    {
      title: "Tasks",
      dataIndex: "task_names",
      sorter: (a: any, b: any) => a.task_names.length - b.task_names.length,
    },
    {
      title: "Projects",
      dataIndex: "project_names",
      sorter: (a: any, b: any) => a.project_names.length - b.project_names.length,
    },
    {
      title: "Date",
      dataIndex: "work_date",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.work_date.length - b.work_date.length,
    },
    {
      title: "Assigned hours",
      dataIndex: "total_hours",
      sorter: (a: any, b: any) => a.total_hours.length - b.total_hours.length,
    },
    {
      title: 'Worked Hrs',
      dataIndex: 'hours_logged',
      key: 'hours_logged',
      render: (text: any, record: any) => (
        <span
          onClick={() => handleWorkedHrsClick(record)}
          style={{
            color: '#1890ff',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "deadline",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.deadline.length - b.deadline.length,
    },
    {
      title: "Request Status",
      dataIndex: "requestStatus",
      render: (RequestStatus: string, record: any) => (
        <Select
          value={RequestStatus}
          onChange={(value) => handleTimesheetStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
        // disabled={timesheetLoadingIds.includes(record.Id)}
        >
          {["Pending", "Approved", "Rejected"].map((statusOption) => (
            <Select.Option key={statusOption} value={statusOption}>
              {statusOption === RequestStatus && timesheetLoadingIds.includes(record.work_id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[statusOption], fontWeight: 500 }}>
                {statusOption}
              </span>
            </Select.Option>
          ))}
        </Select>
      )
    }
  ]

  const overtimeColumns = [
    {
      title: "Employee",
      dataIndex: "employeeName",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" className="img-fluid rounded-circle" />
          </Link>
          <div className="ms-2">
            <Link to="#">{record.employeeName}</Link>
            <div className="fs-12">{record.Role}</div>
          </div>
        </div>
      ),
    },
    { title: "Date", dataIndex: "OvertimeDate", render: (text: string) => formatDate(text, config), },
    { title: "Overtime Hours", dataIndex: "Duration" },
    {
      title: "Status",
      dataIndex: "OvertimeStatus",
      render: (status: number, record: any) => (

        <Select
          value={statusMappingReverse[status]}
          onChange={(value) => handleOvertimeStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={overtimeLoadingIds.includes(record.Id)}
          suffixIcon={
            overtimeLoadingIds.includes(record.Id) ? (
              <LoadingOutlined spin />
            ) : undefined
          }
        >
          {Object.entries(statusMapping).map(([label, val]) => (
            <Select.Option key={val} value={val.toString()}>
              <span style={{ color: statusColors[label], fontWeight: 500 }}>
                {label}
              </span>
            </Select.Option>
          ))}
        </Select>

      )
    },
  ];

  const encashmentcolumns = [
    {
      title: "Employee Name",
      dataIndex: "EmployeeName",
      sorter: (a: any, b: any) => a.EmployeeName - b.EmployeeName,
    },
    {
      title: "LeaveType Name",
      dataIndex: "LeaveTypeName",
      sorter: (a: any, b: any) => a.LeaveType.localeCompare(b.LeaveType),
    },
    {
      title: "LeavesAvailable",
      dataIndex: "LeavesAvailable",
      sorter: (a: any, b: any) => a.LeavesAvailable.localeCompare(b.LeavesAvailable),
    },
    {
      title: "Request Type",
      dataIndex: "RequestType",
      sorter: (a: any, b: any) => a.RequestType.localeCompare(b.RequestType),
    },
    {
      title: "Request Status",
      dataIndex: "Status",
      render: (RequestStatus: string, record: any) => (
        <Select
          value={RequestStatus}
          onChange={(value) => handleEncashmentStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
        // disabled={timesheetLoadingIds.includes(record.Id)}
        >
          {["Pending", "Approved", "Rejected"].map((statusOption) => (
            <Select.Option key={statusOption} value={statusOption}>
              {statusOption === RequestStatus && timesheetLoadingIds.includes(record.work_id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[statusOption], fontWeight: 500 }}>
                {statusOption}
              </span>
            </Select.Option>
          ))}
        </Select>
      )
    },
  ];

  const leaveCancellationColumns = [
    {
      title: "Employee ID",
      dataIndex: "EmployeeNumber",
      render: (text: any, record: any) => <Link to="#" className="ps-4">{record.EmployeeNumber}</Link>,
      sorter: (a: any, b: any) => a.EmployeeNumber - b.EmployeeNumber,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      render: (text: any, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" className="img-fluid rounded-circle" />
          </Link>
          <div className="ms-2"><Link to="#">{record.employeeName}</Link></div>
        </div>
      ),
    },
    { title: "From", dataIndex: "FromDate", render: (text: string) => formatDate(text, config), },
    { title: "To", dataIndex: "ToDate", render: (text: string) => formatDate(text, config), },
    { title: "No of Days", dataIndex: "Duration" },
    { title: "Leave Type", dataIndex: "LeaveType" },
    { title: "Cancellation_reason", dataIndex: "cancellation_reason" },
    {
      title: "Cancellation Status",
      dataIndex: "Cancellation_status",
      render: (text: string, record: any) => (
        <Select
          value={text}
          onChange={(value) => handleleaveCancelStatusChange(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={text === "Approved" || leaveloading.includes(record.Id)}
        >
          {["Pending", "Approved", "Rejected"].map(status => (
            <Select.Option key={status} value={status}>
              {status === text && leaveloading.includes(record.Id) && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              <span style={{ color: statusColors[status], fontWeight: 500 }}>
                {status}
              </span>
            </Select.Option>
          ))}
        </Select>
      )
    },
  ];

  const resignationColumns = [
    {
      title: "Resignation ID",
      dataIndex: "Id",
      render: (text: string, record: any) => (
        <Link to="#" className="ps-4 fw-medium text-dark">
          {record.Id || "N/A"}
        </Link>
      ),
      sorter: (a: any, b: any) => a.Id - b.Id,
    },
    {
      title: "Employee Name",
      dataIndex: "Resigning_Employee",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img
              src={
                record.PictureURL ??
                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
              }
              alt="Employee"
              className="img-fluid rounded-circle"
            />
          </Link>
          <div className="ms-2">
            <Link to="#" className="fw-semibold">
              {record.Resigning_Employee || "N/A"}
            </Link>
            <div className="text-muted fs-12">{record.role || ""}</div>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Resigning_Employee.localeCompare(b.Resigning_Employee),
    },
    {
      title: "Department",
      dataIndex: "Department",
      render: (text: string) => text || "—",
      sorter: (a: any, b: any) => (a.Department || "").localeCompare(b.Department || ""),
    },
    {
      title: "Resignation Date",
      dataIndex: "Resignation_Date",
      render: (text: string) => text ? new Date(text).toLocaleDateString() : "—",
      sorter: (a: any, b: any) => new Date(a.Resignation_Date).getTime() - new Date(b.Resignation_Date).getTime(),
    },
    {
      title: "Notice Date",
      dataIndex: "Notice_Date",
      render: (text: string) => text ? new Date(text).toLocaleDateString() : "—",
      sorter: (a: any, b: any) => new Date(a.Notice_Date).getTime() - new Date(b.Notice_Date).getTime(),
    },
    {
      title: "Status",
      dataIndex: "ResignationStatus",
      render: (text: string, record: any) => (
        <Select
          value={text}
          onChange={(value: string) => updateStatusApproval(value, record)}
          style={{ width: 120 }}
          size="small"
          disabled={text === "Approved" || text === "Rejected" || isStatusUpdating || loadingIds.includes(record.ResignationId)}
        >
          {["Pending", "Approved", "Rejected"].map((status) => (
            <Select.Option key={status} value={status}>
              <span style={{ color: status === "Pending" ? "#faad14" : status === "Approved" ? "#52c41a" : "#ff4d4f", fontWeight: 600 }}>
                {status}
              </span>
            </Select.Option>
          ))}
        </Select>
      ),
    },
  ];


  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div>
            <h2 className="mb-1">Request Approval Dashboard</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><Link to={all_routes.adminDashboard}><i className="ti ti-smart-home" /></Link></li>
                <li className="breadcrumb-item">Dashboard</li>
                <li className="breadcrumb-item active">Request Approval Dashboard</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            <div className="me-2 mb-2">
              <div className="dropdown">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-file-export me-1" />
                  Export
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <button
                      onClick={() => {
                        if (activeTab === "1") exportToCSV(exportLeavesRequest, 'leave_requests_data');
                        else if (activeTab === "2") exportToCSV(exportOvertimes, 'overtime_requests_data');
                        else if (activeTab === "3") exportToCSV(exportAssetRequest, 'asset_requests_data');
                        else if (activeTab === "4") exportToCSV(exportAssetRequestMaintainance, 'asset_maintenance_data');
                        else if (activeTab === "5") exportToCSV(exportExpenseData, 'reimbursement_data');
                        else if (activeTab === "6") exportToCSV(exportWorkfromhome, 'work_from_home_data');
                        else if (activeTab === "7") exportToCSV(DataTimeSheeetForExport, 'TimeSheet_data');
                        else if (activeTab === "8") exportToCSV(exportLeaveEncashments, 'Encashment_data');
                        else if (activeTab === "9") exportToCSV(DatafromExportCancellation, 'leave_Cancellation');
                      }}
                      className="dropdown-item rounded-1"
                    >
                      <i className="ti ti-file-type-pdf me-1" />
                      Export as CSV
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        if (activeTab === "1") exportToExcel(exportLeavesRequest, 'leave_requests_data');
                        else if (activeTab === "2") exportToExcel(exportOvertimes, 'overtime_requests_data');
                        else if (activeTab === "3") exportToExcel(exportAssetRequest, 'asset_requests_data');
                        else if (activeTab === "4") exportToExcel(exportAssetRequestMaintainance, 'asset_maintenance_data');
                        else if (activeTab === "5") exportToExcel(exportExpenseData, 'reimbursement_data');
                        else if (activeTab === "6") exportToExcel(exportWorkfromhome, 'work_from_home_data');
                        else if (activeTab === "7") exportToExcel(DataTimeSheeetForExport, 'TimeSheet_data');
                        else if (activeTab === "8") exportToExcel(exportLeaveEncashments, 'Encashment_data');
                        else if (activeTab === "9") exportToExcel(DatafromExportCancellation, 'leave_Cancellation');
                      }}
                      className="dropdown-item rounded-1"
                    >
                      <i className="ti ti-file-type-xls me-1" />
                      Export as Excel{" "}
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div className="ms-2 head-icons">
              <CollapseHeader />
            </div>
          </div>
          {/* <div className="ms-2 head-icons"><CollapseHeader /></div> */}
        </div>

        <Tabs defaultActiveKey="1" onChange={(key) => setActiveTab(key)}>
          <TabPane tab="🌿 Leave & Time-Off Requests" key="1">
            <div className="row mb-4">{getStatusCards(leaveData, "LeaveRequestStatus")}</div>
            <div className="card">
              <FilterHeader {...{ selectedStatus, setSelectedStatus, selectedSort, setSelectedSort }} />
              <div className="card-body p-0">
                <Table key={tableKey} dataSource={filteredLeaves} columns={leaveColumns} Selection={false} />
              </div>
            </div>
          </TabPane>

          <TabPane tab="🧾 Overtime" key="2">
            <div className="row mb-4">{getStatusCards(overtimeData, "OvertimeStatus")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedOvertimeStatus}
                setSelectedStatus={setSelectedOvertimeStatus}
                selectedSort={selectedOvertimeSort}
                setSelectedSort={setSelectedOvertimeSort}
              />
              <div className="card-body p-0">
                <Table key={overtimeTableKey} dataSource={filteredOvertimes} columns={overtimeColumns} Selection={false} />
              </div>
            </div>
          </TabPane>

          <TabPane tab="🖥️ Asset Request" key="3">
            <div className="row mb-4">{getStatusCards(assetData, "AssetRequestStatus")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table key={assetTableKey} dataSource={filteredAssetRequests} columns={assetColumns} Selection={false} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="🖥️ Asset Request Maintenance" key="4">
            <div className="row mb-4">{getStatusCards(maintenanceData, "request_status")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table key={assetMaintenaceTableKey} dataSource={filteredAssetMaintenaceData} columns={assetMaintenanceColumns} Selection={false} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="🖥️ Reimbursement Request " key="5">
            <div className="row mb-4">{getStatusCards(expenseData, "requestStatus")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table key={expenseTableKey} dataSource={filteredExpenseData} columns={ExpenseColumns} Selection={false} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="🖥️Work From Home Request" key="6">
            <div className="row mb-4">{getStatusCards(wfhData, "RequestStatus")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table key={WFHTableKey} dataSource={filteredWorkfromhome} columns={workfromhomecolumns} Selection={false} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="🖥️Timesheet Request" key="7">
            <div className="row mb-4">{getStatusCards(worklogData, "requestStatus")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table key={timeTableKey} dataSource={filteredtimesheetData} columns={timesheetcolumns} Selection={false} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="🖥️Encashment Request" key="8">
            <div className="row mb-4">{getStatusCards(filteredencashmentData, "Status")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table key={enhancementKey} dataSource={filteredencashmentData} columns={encashmentcolumns} Selection={false} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="🖥️Leave cancellation" key="9">
            <div className="row mb-4">{getStatusCards(filteredcancellationdata, "Cancellation_status")}</div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table key={cancellationKey} dataSource={filteredcancellationdata} columns={leaveCancellationColumns} Selection={false} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="⏱️ Resignation Requests" key="10">
            <div className="row mb-4">
              {getStatusCards(resignationData, "LeaveRequestStatus")}
            </div>
            <div className="card">
              <FilterHeader
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
              />
              <div className="card-body p-0">
                <Table
                  key={`hierarchy-${resignationKey}`}
                  dataSource={filteredResignation}
                  columns={resignationColumns}
                // Selection={false}
                />
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
      <Modal
        title={`Reject ${modalType} Request`}
        open={rejectModalVisible}
        onOk={() => {
          if (!rejectDescription.trim()) {
            message.error("Please enter a reason for rejection.");
            return;
          }
          modalType === "Asset"
            ? updateStatus("Rejected", currentRejectRecord, rejectDescription)
            : modalType === "Overtime"
              ? updateOvertimeStatus("Rejected", currentRejectRecord, rejectDescription)
              : modalType === "Leave"
                ? updateLeaveStatus("Rejected", currentRejectRecord, { description: rejectDescription })
                : modalType === "AssetMaintenance"
                  ? updateAssetMaintenanceStatus("Rejected", currentRejectRecord, rejectDescription)
                  : modalType === "Reimbursement"
                    ? updateExpenseStatus("Rejected", currentRejectRecord, rejectDescription)
                    : modalType === "TimeSheet"
                      ? updateTimesheetStatus("Rejected", currentRejectRecord, rejectDescription)
                      : modalType === "Encashment"
                        ? updateEncashmentStatus("Rejected", currentRejectRecord, rejectDescription)
                        : modalType === "WorkFromHome"
                          ? updateWorkfromStatus("Rejected", currentRejectRecord, rejectDescription)
                          : modalType === "LeaveCancellation"
                            ? updateLeaveCancelStatus("Rejected", currentRejectRecord, rejectDescription)
                            : message.error("Unknown request type");

          setRejectModalVisible(false);
          setRejectDescription("");
        }}
        onCancel={() => {
          setRejectModalVisible(false);
          setRejectDescription("");
        }}
      >
        <Input.TextArea
          rows={4}
          value={rejectDescription}
          onChange={(e) => setRejectDescription(e.target.value)}
          placeholder="Enter rejection reason..."
        />
      </Modal>

      <Modal
        title="Enter Number of Days"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => {
          if (modalRecord) {
            updateLeaveStatus("Approved", modalRecord, { duration: daysInput });
            setIsModalVisible(false);
          }
        }}
      >
        <Input
          type="number"
          min={1}
          value={daysInput}
          onChange={(e) => setDaysInput(Number(e.target.value))}
        />
      </Modal>

      <Modal
        show={isDetailsModalOpen}
        onHide={() => setIsDetailsModalOpen(false)}
        centered
        size="lg"
      >
        {selectedDetails && (
          <>
            <Modal.Header closeButton>
              <div className="d-flex align-items-center">
                <div>
                  <h5 className="mb-0">{selectedDetails.employee_name}</h5>
                  <small className="text-muted">
                    Date:{" "}
                    {new Date(selectedDetails.work_date).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </small>
                </div>
              </div>
            </Modal.Header>

            <Modal.Body
              style={{
                maxHeight: "60vh",
                overflowY: "auto",
                backgroundColor: "#f9fafb",
              }}
            >
              {selectedDetails.details && selectedDetails.details.length > 0 ? (
                selectedDetails.details.map((item: any, index: number) => (
                  <Card
                    key={item.work_id}
                    className="mb-3 shadow-sm border-0"
                    style={{ borderRadius: "12px" }}
                  >
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">
                          #{index + 1} — {item.task_name || "Untitled Task"}
                        </h6>

                        <Select
                          value={item.requestStatus}
                          size="small"
                          style={{ width: 130 }}
                          onChange={(value) => handleTimesheetStatusChangeFromModal(value, item)}
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        >
                          {["Pending", "Approved", "Rejected"].map((statusOption) => (
                            <Select.Option key={statusOption} value={statusOption}>
                              {modalLoadingIds.includes(item.work_id) &&
                                statusOption === item.requestStatus && (
                                  <span className="spinner-border spinner-border-sm me-1"></span>
                                )}
                              <span style={{ color: statusColors[statusOption], fontWeight: 500 }}>
                                {statusOption}
                              </span>
                            </Select.Option>
                          ))}
                        </Select>

                      </div>


                      <Row className="mb-2">
                        <Col xs={12} md={6}>
                          <strong>Project:</strong> {item.project_name || "N/A"}
                        </Col>
                        <Col xs={12} md={6}>
                          <strong>Priority:</strong> {item.priority || "—"}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col>
                          <strong>Description:</strong> {item.description || "—"}
                        </Col>
                      </Row>

                      <Row className="text-center mb-3">
                        <Col>
                          <div
                            className="p-2 bg-light rounded"
                            style={{ minHeight: "60px" }}
                          >
                            <small className="text-muted">Hours Logged</small>
                            <div className="fw-semibold">{item.hours_logged}</div>
                          </div>
                        </Col>
                        <Col>
                          <div
                            className="p-2 bg-light rounded"
                            style={{ minHeight: "60px" }}
                          >
                            <small className="text-muted">Total Hours</small>
                            <div className="fw-semibold">{item.total_hours}</div>
                          </div>
                        </Col>
                        <Col>
                          <div
                            className="p-2 bg-light rounded"
                            style={{ minHeight: "60px" }}
                          >
                            <small className="text-muted">Remaining</small>
                            <div className="fw-semibold">{item.remaining_hours}</div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="text-center">
                        <Col>
                          <div className="p-2 bg-light rounded">
                            <small className="text-muted">Status</small>
                            <div className="fw-semibold">{item.status}</div>
                          </div>
                        </Col>
                        <Col>
                          <div className="p-2 bg-light rounded">
                            <small className="text-muted">Deadline</small>
                            <div className="fw-semibold">
                              {new Date(item.deadline).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))
              ) : (
                <div className="text-center text-muted py-4">
                  No work details found.
                </div>
              )}
            </Modal.Body>
          </>
        )}
      </Modal>;



    </div>
  );
};

export default RequestDashboard;